export default __webpack_public_path__ + "static/media/02.d5448c2f.jpeg";